module.exports = __webpack_public_path__ + "img/diretorio_grupos.7f4372b4.png";